import styles from './Login.module.scss';

import { Screen } from '@/components/Screen';
import { useStore } from '@/store';

import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { AlgoAuthButton } from './AlgoAuthButton';
import { LoginButton } from './LoginButton';

export const Login = () => {
  const { accountStore } = useStore();
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  useEffect(() => {
    if (accountStore.accountData?._id) {
      const from = location.state?.from?.pathname || '/';
      navigate(from, { replace: true });
    }
  }, [accountStore.accountData?._id]);

  return (
    <Screen className={styles.screen}>
      <div className={styles.login}>
        <div className={styles.loginTitle}>{t('Sign in to continue')}</div>
        <div className={styles.loginButtons}>
          <LoginButton>{t('Continue with Google')}</LoginButton>
          <AlgoAuthButton>{t('Continue with Algo Wallet')}</AlgoAuthButton>
        </div>
      </div>
    </Screen>
  );
};
